<template>
  <RouterView />
</template>

<script>
export default {
  data () {
    return {
      title: 'Users',
      breadcrumb: {
        name: 'Users',
        route: {
          name: 'manage-users'
        }
      }
    }
  }
}
</script>
